import Select from 'react-select';
import React, { useState, useEffect ,useMemo } from 'react'
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { useLoading } from '../../../context/LoadingContext';
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function AccountReport() {

const { setLoading } = useLoading();
 const [noteType, setNoteType] = useState(null);
   const [issueDate, setIssueDate] = useState('');
   const [fetchData, setfetchData] = useState([]);
 
   const [fromDate, setFromDate] = useState('');
   const [toDate, setToDate] = useState('');
     const [accountDetail, setAccountDetail] = useState([]);
 const [fetchSale, setFetchSale] = useState([]);
const [amc, setAmc] = useState([]);
         const [fetchRepairInvoice, setFetchRepairInvoice] = useState([]);
   const[fetchPurhcase,setFetchPurchase] = useState([]);  
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };
const [typeFilter, setTypeFilter] = useState('all');
const [selectedType, setSelectedType] = useState('all');
const [selectedGroup, setSelectedGroup] = useState('ALL');
const [filterType, setFilterType] = useState('all');

const [showYearModal, setShowYearModal] = useState(false);
const [confirmProcess, setConfirmProcess] = useState(false);
const [yearContext, setYearContext] = useState(null);
const [yearPreviewLoading, setYearPreviewLoading] = useState(false);
const [closePending, setClosePending] = useState(false);
const [yearMessage, setYearMessage] = useState('');


       const reportOptions = [
          { value: 'account_document', label: 'Account Documents' },
            { value: 'account_master', label: 'Account Master' },
        { value: 'bank_book', label: 'Bank Book' },
          { value: 'cash_book', label: 'Cash Book' },
         { value: 'cash_flow_sts', label: 'Cash Flow Statement' },
        { value: 'bill_wise_pay', label: 'Bill Wise Payment Report' },
         { value: 'bill_wise_receive', label: 'Bill Wise Receive Report ' }, 
         { value: 'general_ledger', label: 'General Ledger ' }, 
          { value: 'outstand_bill', label: 'Outstand Bill ' }, 
          { value: 'unallocated_voucher', label: 'Unallocated Voucher' },  
        { value: 'ledger_job_wise', label: 'Ledger Job Wise' }, 
         { value: 'trail_balance', label: 'Trail balance' },  
           { value: 'trail_balance_detail', label: 'Trail balance Detail' }, 
         { value: 'profit_and_loss', label: 'Profit And Loss' }, 
           { value: 'balance_sheet', label: 'Balance Sheeet' }, 
          { value: 'trading_account', label: 'Trading Account' },  
              { value: 'stock_statement', label: 'Stock statement' },     
  ]


   const fecthAccountDetail = async () => {
        try {
            const resParty = await axios.get('https://api.skyguard.group/api/fetch-account');
            const result = resParty.data.result;

              const filteredResult = result.filter(
            (item) => item.party_id === 0 || item.party_id === null
        );

        setAccountDetail(filteredResult);
        } catch (error) {
            console.log(error)
        }
    };

      useEffect(() => {
          // fetchAllData();
            fecthAccountDetail();
        }, []);
  


const handleSearch = async (e) => {
  e.preventDefault();

     if (!noteType?.value) {
      setToast('Please select a report type', 'warning');
      return;
    }
    if (!fromDate || !toDate) {
      setToast('Please select From Date and To Date', 'warning');
      return;
    }

  try {
 const params = {
  note_type: noteType.value,
  from_date: fromDate,
  to_date: toDate
};


  
    const result = await axios.get(
      'https://api.skyguard.group/api/get-account-report',
      { params }
    );

    setfetchData(result.data.result || []);
    // console.log('Report result:', result.data.result);

  } catch (error) {
    console.error('Error fetching report:', error);
  }
};

const getRefDoc = (item) => {
  if (item.payment_type === 'bank_payment') {
    return `BP/${item.inv_no}/${item.branchName}`;
  }

  if (item.payment_type === 'cash_payment') {
    return `CP/${item.inv_no}/${item.branchName}`;
  }
  
  if (item.payment_type === 'bank_receipt') {
    return `BR/${item.inv_no}/${item.branchName}`;
  }

   if (item.payment_type === 'cash_receipt') {
    return `CR/${item.inv_no}/${item.branchName}`;
  }


  return '-';
};

const fetchPurchaseDetail = async (fromDate, toDate) => {
  setLoading(true);
  try {
    const resPurchase = await axios.get(
      "https://api.skyguard.group/api/fetch-purchase",
      {
        params: {
          from: fromDate,
          to: toDate      
        }
      }
    );

    const data = Array.isArray(resPurchase.data)
      ? resPurchase.data
      : resPurchase.data?.data || [];

    const purchaseOnly = data.filter(
      item => item.type_acc === "Purchase"
    );

    // setPurchase(purchaseOnly);
    // console.log(purchaseOnly);

  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};



const fetchAllData = async () => {
  setLoading(true);
  try {
    const params = {
      from_date: fromDate,
      to_date: toDate     
    };

    const [saleRes, amcRes, repairRes, purchaseRes] = await Promise.all([
      axios.get('https://api.skyguard.group/api/fetch-sale-invoice', { params }),
      axios.get('https://api.skyguard.group/api/fetch-amc', { params }),
      axios.get('https://api.skyguard.group/api/fetch-repair-invoice', { params }),
      axios.get('https://api.skyguard.group/api/fetch-purchase', { params })
    ]);

    // Sale Invoices
    const saleInvoiceOnly = saleRes.data
      .filter(item => item.type_acc === "sale_invoice")
      .filter(item => 
          (item.received_amount === null || item.received_amount === "" || item.received_amount === undefined) 
          || Number(item.received_amount) < Number(item.grand_total)
      )
      .map(item => ({
          ...item,
          source_type: "sale_invoice"
      }));

    // Repair Invoices
    const repairInvoiceOnly = repairRes.data
      .filter(item => item.type_acc === "repair_invoice")
      .filter(item => 
          (item.received_amount === null || item.received_amount === "" || item.received_amount === undefined)
          || Number(item.received_amount) < Number(item.grand_total)
      )
      .map(item => ({
          ...item,
          source_type: "repair_invoice"
      }));

    // AMC
    const amcData = amcRes.data
      .filter(item => 
          (item.received_amount === null || item.received_amount === "" || item.received_amount === undefined)
          || Number(item.received_amount) < Number(item.grand_total)
      )
      .map(item => ({
          ...item,
          source_type: "amc"
      }));

    // Purchase
    const purchaseOnly = purchaseRes.data
      .filter(item => item.type_acc === "Purchase")
      .filter(item => 
          (item.allocated_amount === null || item.allocated_amount === "" || item.allocated_amount === undefined)
          || Number(item.allocated_amount) < Number(item.grand_total)
      )
      .map(item => ({
          ...item,
          source_type: "purchase"
      }));

    // Set state
    setFetchSale(saleInvoiceOnly);
    setAmc(amcData);
    setFetchRepairInvoice(repairInvoiceOnly);
    setFetchPurchase(purchaseOnly);

    const allData = [
  ...saleInvoiceOnly .map(d => ({ ref_doc: d.ref_doc || "Sale", date: d.quotation_date })),
  ...repairInvoiceOnly.map(d => ({ ref_doc: d.ref_doc || "Repair", items: d.items })),
  ...amcData.map(d => ({ ref_doc: d.ref_doc || "AMC", items: d.items })),
  ...purchaseOnly.map(d => ({ ref_doc: d.ref_doc || "Purchase", items: d.items }))
];


setfetchData(allData);
// console.log('all merged data',allData);
    return {
      saleInvoiceOnly,
      amcData,
      repairInvoiceOnly
    };

  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    setLoading(false);
  }
};


const grouped = fetchData.reduce((acc, item) => {

  
  const key = item.main_account || item.contra_account_name || 'Unknown';

  if (!acc[key]) {
    acc[key] = [];
  }

  acc[key].push(item);

  return acc;

}, {});


const typeOptions = [
  'all',
  ...new Set(fetchData.map(item => item.account_type).filter(Boolean))
];

const normalize = (str) => {
  if (!str) return '';

  return str
    .toLowerCase()
    .replace(/[_-]/g, ' ')   
    .replace(/\s+/g, ' ')   
    .trim();
};

const handleExportExcel = () => {
  const table = document.getElementById("exportTable");

  if (!table) return;

  const worksheet = XLSX.utils.table_to_sheet(table);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(data, "Report.xlsx");
};





const groupedData = fetchData?.reduce((acc, item) => {

  const mainGroup = item.master_type_account || 'Others';

  const subGroup =
    item.account_holder_name ||
    item.party_name ||
    item.account_code ||
    'Unknown';

  if (!acc[mainGroup]) {
    acc[mainGroup] = {};
  }

  if (!acc[mainGroup][subGroup]) {
    acc[mainGroup][subGroup] = [];
  }

  acc[mainGroup][subGroup].push(item);

  return acc;

}, {});




const trialBalanceGroupedData = (fetchData || []).reduce((acc, item) => {

  const groupHead = item.master_type_account || 'Others';

  const subAccount =
    item.account_holder_name ||
    item.party_name ||
    'Unknown';

  if (!acc[groupHead]) acc[groupHead] = {};
  if (!acc[groupHead][subAccount]) acc[groupHead][subAccount] = [];

  acc[groupHead][subAccount].push(item);

  return acc;

}, {});

const plGrouped = (fetchData || []).reduce((acc, item) => {

  const rows = item.parsedRows || [];

  rows.forEach(r => {

    const accountName =
      r.account?.label ||
      r.account_name ||
      'Unknown';

    const amount = parseFloat(r.amount || 0);
    const type = (r.type || '').toLowerCase(); // Dr / Cr

    if (!acc[accountName]) {
      acc[accountName] = { dr: 0, cr: 0 };
    }

    if (type === 'dr') {
      acc[accountName].dr += amount;
    } else {
      acc[accountName].cr += amount;
    }

  });

  return acc;

}, {});



const computedData = Object.entries(trialBalanceGroupedData || {}).map(
  ([groupHead, accounts]) => {

    let groupDr = 0;
    let groupCr = 0;

    const accountRows = Object.entries(accounts || {}).map(
      ([accountName, items]) => {

        let openingBalance = parseFloat(items?.[0]?.opening_balance || 0);

        let totalDr = 0;
        let totalCr = 0;
        let runningBalance = openingBalance;

        (items || []).forEach(item => {

          const amount = parseFloat(
            item?.parsedRows?.[0]?.amount ||
            item?.amount ||
            0
          );

          const type = (item?.payment_type || item?.type_acc || '').toLowerCase();

          const isCredit =
            type === 'bank_receipt' ||
            type === 'cash_receipt' ||
            type === 'sale_invoice';

          if (isCredit) {
            totalCr += amount;
            runningBalance += amount;
          } else {
            totalDr += amount;
            runningBalance -= amount;
          }
        });

        groupDr += totalDr;
        groupCr += totalCr;

        return {
          accountName,
          openingBalance,
          totalDr,
          totalCr,
          runningBalance
        };
      }
    );

    return {
      groupHead,
      accounts: accountRows,
      groupDr,
      groupCr
    };
  }
);



const groupedTradingAccountData = useMemo(() => {
  const data = fetchData || [];

  const groups = {
    sales: [],
    purchase: [],
    amc: [],
    expense: [],
  };

  data.forEach(item => {
    const amount = Number(item.grand_total || 0);

    if (
      item.source_table === 'sales' ||
      item.type_acc === 'sale_invoice' ||
      item.type_acc === 'sale_return'
    ) {
      groups.sales.push(item);
    }

    else if (
      item.source_table === 'purchase' ||
      item.type_acc === 'Purchase'
    ) {
      groups.purchase.push(item);
    }

    else if (
      item.source_table === 'amc_detail' ||
      item.type_acc === 'amc'
    ) {
      groups.amc.push(item);
    }

    else if (
      item.source_table === 'payment_detail' &&
      item.master_type_account === 'Indirect Expense'
    ) {
      groups.expense.push(item);
    }
  });

  return groups;
}, [fetchData]);

const totals = {
  sales: groupedTradingAccountData.sales.reduce(
    (sum, i) => sum + Number(i.grand_total || 0), 0
  ),

  purchase: groupedTradingAccountData.purchase.reduce(
    (sum, i) => sum + Number(i.grand_total || 0), 0
  ),

  amc: groupedTradingAccountData.amc.reduce(
    (sum, i) => sum + Number(i.grand_total || 0), 0
  ),

  expense: groupedTradingAccountData.expense.reduce(
    (sum, i) => sum + Number(i.grand_total || 0), 0
  ),
};

groupedTradingAccountData.sales = fetchData.filter(item =>
  item.source_table === 'sales' ||
  item.source_table === 'amc_detail' ||
  item.source_table === 'repair_item' ||
  item.type_acc === 'sale_invoice' ||
  item.type_acc === 'sale_return' ||
  item.type_acc === 'amc'
);

groupedTradingAccountData.purchase = fetchData.filter(item =>
  item.source_table === 'purchase' ||
  item.type_acc === 'Purchase'
);

groupedTradingAccountData.indirect_expense = fetchData.filter(item =>
  item.source_table === 'payment_detail' &&
  item.master_type_account === 'Indirect Expense'
);

const filteredSales =
  filterType === 'all' || filterType === 'sales'
    ? groupedTradingAccountData.sales
    : [];

const filteredPurchase =
  filterType === 'all' || filterType === 'purchase'
    ? groupedTradingAccountData.purchase
    : [];

const filteredExpense =
  filterType === 'all' || filterType === 'expense'
    ? groupedTradingAccountData.indirect_expense
    : [];



const openFinancialYearModal = async () => {
  setShowYearModal(true);
  setConfirmProcess(false);
  setYearContext(null);
  setYearMessage('');
  setYearPreviewLoading(true);
  try {
    const { data: years } = await axios.get('https://api.skyguard.group/api/fetch-year-list');
    const sources = years.filter(year => year.from_date === fromDate && year.to_date === toDate);
    if (!fromDate || !toDate || sources.length !== 1) {
      throw new Error('Select the complete From Date and To Date of one financial year.');
    }
    const source = sources[0];
    const end = new Date(`${source.to_date}T00:00:00.000Z`);
    const start = new Date(end);
    start.setUTCDate(start.getUTCDate() + 1);
    const nextEnd = new Date(end);
    nextEnd.setUTCDate(1);
    nextEnd.setUTCFullYear(end.getUTCFullYear() + 1);
    nextEnd.setUTCMonth(end.getUTCMonth() + 1, 0);
    nextEnd.setUTCDate(Math.min(end.getUTCDate(), nextEnd.getUTCDate()));
    const targetFrom = start.toISOString().slice(0, 10);
    const targetTo = nextEnd.toISOString().slice(0, 10);
    const targets = years.filter(year => year.from_date === targetFrom && year.to_date === targetTo);
    if (targets.length > 1) throw new Error('Multiple target financial years have the same dates.');
    const labelFormat = /^(\d{2}|\d{4})-(\d{2}|\d{4})$/.exec(source.financial_year || '');
    const firstYear = String(start.getUTCFullYear());
    const lastYear = String(nextEnd.getUTCFullYear());
    const target = targets[0] || {
      financial_year: `${labelFormat ? firstYear.slice(-labelFormat[1].length) : firstYear}-${labelFormat ? lastYear.slice(-labelFormat[2].length) : lastYear}`,
      from_date: targetFrom, to_date: targetTo
    };
    setYearContext({ source, target });
    if (source.closed_at || source.closed_to_year_id) {
      setYearMessage('This source financial year has already been closed.');
    }
  } catch (error) {
    setYearMessage(error.response?.data?.message || error.message || 'Unable to resolve financial years.');
  } finally {
    setYearPreviewLoading(false);
  }
};

const handleFinancialYearChange = async () => {
  if (closePending || !yearContext || !confirmProcess) return;
  setClosePending(true);
  setYearMessage('');
  try {
    const { source, target } = yearContext;
    const { data } = await axios.post('https://api.skyguard.group/api/financial-year-close', {
      from_date: source.from_date,
      to_date: source.to_date,
      source_year_id: source.id,
      ...(target.id ? { target_year_id: target.id } : {})
    });
    if (!data.success) throw new Error(data.message || 'Financial year close failed.');
    alert(`Account balances closed successfully. ${data.accounts_closed} account openings carried forward to ${data.target_from_date} through ${data.target_to_date}.`);
    setShowYearModal(false);
    setConfirmProcess(false);
  } catch (error) {
    setYearMessage(error.response?.data?.message || error.message || 'Financial year close failed.');
    setConfirmProcess(false);
  } finally {
    setClosePending(false);
  }
};

  return (
  <>
      <div className='main-section'>
           <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
               <h3 className='my-3 fw-bold fs-5 golos'>Account Report</h3>
                 <div className="row g-3 align-items-end">

                  
            <div className="col-md-4">
              <label className='fw-bold'>Select Report</label>
              <Select
                options={reportOptions}
                placeholder="Choose Type ..."
                id="source"
                value={noteType}
       
                onChange={(selected) => {
                  setNoteType(selected);
                  setfetchData([]);
                }}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>From Date</label>
              <input
                type="date"
                className="form-control"
                name="from_date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>To Date</label>
              <input
                type="date"
                className="form-control"
                name="to_date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>


            <div className="col-md-12 d-flex justify-content-end align-items-end">
             
               <FaSearch size={26} className="ms-1 text-primary"
                              style={{ cursor: "pointer" }}
                              title="Search"
                              onClick={handleSearch}
                            />
              
                            <MdLocalPrintshop
                              size={26}
                              className="ms-1 text-success"
                                 onClick={handleExportExcel}
                              style={{ cursor: "pointer" }}
                              title="Print "
                            />

                            <button className='btn btn-danger' onClick={openFinancialYearModal}>New Year Process</button>
            </div>

            
          </div>


 <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>

   {noteType?.value === 'bank_book' && (
              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    
                    <th>Ref Doc</th>
                    <th>Date</th>
                    <th>Cheque No. </th>
                    <th>Account</th>
                  
                   <th>Credit</th>
                      <th>Debit</th>
                  </tr>
                </thead>
 {/* <tbody>
  {Object.keys(grouped).length > 0 ? (
    Object.entries(grouped).map(([mainAccount, items], idx) => (
      <React.Fragment key={idx}>

    
        <tr className="table-primary">
          <td colSpan="6" className="text-start fw-bold">
            {mainAccount}
          </td>
        </tr>

        {items.map((item, i) => {
          let rows = [];

          try {
            rows = JSON.parse(JSON.parse(item.tableRow));
            if (!Array.isArray(rows)) rows = [];
          } catch {
            rows = [];
          }

          return rows.map((row, rIdx) => (
            <tr key={rIdx}>

             <td>
  {item.payment_type === 'bank_payment'
    ? `BP/${item.inv_no}/${item.branchName || ''}`
    : item.payment_type === 'bank_receipt'
      ? `BR/${item.inv_no}/${item.branchName || ''}`
      : `CO/${item.inv_no}/${item.branchName || ''}`}
</td>

         
              <td>
                {new Date(item.payment_date).toLocaleDateString()}
              </td>

           
              <td>{item.cheque_no || '-'}</td>

    
              <td>{row.account?.label || '-'}</td>

          
              <td>
                {item.payment_type === 'bank_receipt'
                  ? row.amount
                  : ''}
              </td>

 
              <td>
                {item.payment_type === 'bank_payment'
                  ? row.amount
                  : ''}
              </td>

            </tr>
          ));
        })}

      </React.Fragment>
    ))
  ) : (
    <tr>
      <td colSpan="6">No data found</td>
    </tr>
  )}
</tbody> */}


<tbody>
  {Object.keys(grouped).length > 0 ? (
    Object.entries(grouped).map(([mainAccount, items], idx) => (

      <React.Fragment key={idx}>

        {/* MAIN ACCOUNT HEADER */}
        <tr className="table-primary">
          <td colSpan="6" className="text-start fw-bold">
            {mainAccount}
          </td>
        </tr>
        {items.map((item, i) => {
 
if (item.isContra) {

  let parsedRows = [];

  try {
    parsedRows = JSON.parse(JSON.parse(item.tableRow || "[]"));

    if (!Array.isArray(parsedRows)) {
      parsedRows = [];
    }

  } catch {
    parsedRows = [];
  }

  // ✔ FIND CURRENT GROUP ROW
  const currentGroupRow = parsedRows.find(r => {

    const accId =
      typeof r.account === 'object'
        ? r.account.value
        : r.account;

    return (
      String(accId) === String(item.contra_account)
    );
  });

  // ✔ THIS CONTRA DOES NOT BELONG TO CURRENT GROUP
  if (!currentGroupRow) {
    return null;
  }

  // ✔ FIND OPPOSITE ENTRY
  const oppositeRow = parsedRows.find(r => {

    const accId =
      typeof r.account === 'object'
        ? r.account.value
        : r.account;

    return (
      String(accId) !== String(item.contra_account)
    );
  });

  if (!oppositeRow) {
    return null;
  }

  return (
    <tr key={i}>

      {/* REF DOC */}
      <td>
        CO/{item.inv_no}/{item.branchName || ''}
      </td>

      {/* DATE */}
      <td>
        {new Date(item.payment_date).toLocaleDateString()}
      </td>

      {/* CHEQUE */}
      <td>{item.cheque_no || '-'}</td>

 <td>
  {typeof oppositeRow.account === 'object'
    ? oppositeRow.account.label
    : item.contra_account_name || '-'}
</td>

      {/* CREDIT */}
      <td>
        {oppositeRow.type === 'Cr'
          ? oppositeRow.amount
          : ''}
      </td>

      {/* DEBIT */}
      <td>
        {oppositeRow.type === 'Dr'
          ? oppositeRow.amount
          : ''}
      </td>

    </tr>
  );
}
          // =========================================
          // ✔ NORMAL FLOW
          // =========================================

          let rows = [];

          try {
            rows = JSON.parse(JSON.parse(item.tableRow || "[]"));

            if (!Array.isArray(rows)) {
              rows = [];
            }

          } catch {
            rows = [];
          }

          return rows.map((row, rIdx) => (

            <tr key={`${i}-${rIdx}`}>

              {/* REF DOC */}
              <td>
                {item.payment_type === 'bank_payment'
                  ? `BP/${item.inv_no}/${item.branchName || ''}`
                  : `BR/${item.inv_no}/${item.branchName || ''}`}
              </td>

              {/* DATE */}
              <td>
                {new Date(item.payment_date).toLocaleDateString()}
              </td>

              {/* CHEQUE */}
              <td>{item.cheque_no || '-'}</td>

              {/* ACCOUNT */}
              <td>
                {typeof row.account === 'object'
                  ? row.account.label
                  : '-'}
              </td>

              {/* CREDIT */}
              <td>
                {item.payment_type === 'bank_receipt'
                  ? row.amount
                  : ''}
              </td>

              {/* DEBIT */}
              <td>
                {item.payment_type === 'bank_payment'
                  ? row.amount
                  : ''}
              </td>

            </tr>
          ));

        })}

      </React.Fragment>
    ))
  ) : (
    <tr>
      <td colSpan="6">No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}



    {noteType?.value === 'cash_book' && (
              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    
                    <th>Ref Doc</th>
                    <th>Date</th>
                    <th>Cheque No. </th>
                    <th>Account</th>
                  
                   <th>Credit</th>
                      <th>Debit</th>
                  </tr>
                </thead>
 

<tbody>
  {Object.keys(grouped).length > 0 ? (
    Object.entries(grouped).map(([mainAccount, items], idx) => (

      <React.Fragment key={idx}>

        {/* MAIN ACCOUNT HEADER */}
        <tr className="table-primary">
          <td colSpan="6" className="text-start fw-bold">
            {mainAccount}
          </td>
        </tr>
        {items.map((item, i) => {
 
if (item.isContra) {

  let parsedRows = [];

  try {
    parsedRows = JSON.parse(JSON.parse(item.tableRow || "[]"));

    if (!Array.isArray(parsedRows)) {
      parsedRows = [];
    }

  } catch {
    parsedRows = [];
  }

  const currentGroupRow = parsedRows.find(r => {

    const accId =
      typeof r.account === 'object'
        ? r.account.value
        : r.account;

    return (
      String(accId) === String(item.contra_account)
    );
  });

  if (!currentGroupRow) {
    return null;
  }

  // ✔ FIND OPPOSITE ENTRY
  const oppositeRow = parsedRows.find(r => {

    const accId =
      typeof r.account === 'object'
        ? r.account.value
        : r.account;

    return (
      String(accId) !== String(item.contra_account)
    );
  });

  if (!oppositeRow) {
    return null;
  }

  return (
    <tr key={i}>

      <td>
        CO/{item.inv_no}/{item.branchName || ''}
      </td>

 
      <td>
        {new Date(item.payment_date).toLocaleDateString()}
      </td>

      {/* CHEQUE */}
      <td>{item.cheque_no || '-'}</td>

 <td>
  {typeof oppositeRow.account === 'object'
    ? oppositeRow.account.label
    : item.contra_account_name || '-'}
</td>

      {/* CREDIT */}
      <td>
        {oppositeRow.type === 'Cr'
          ? oppositeRow.amount
          : ''}
      </td>

      {/* DEBIT */}
      <td>
        {oppositeRow.type === 'Dr'
          ? oppositeRow.amount
          : ''}
      </td>

    </tr>
  );
}
        

          let rows = [];

          try {
            rows = JSON.parse(JSON.parse(item.tableRow || "[]"));

            if (!Array.isArray(rows)) {
              rows = [];
            }

          } catch {
            rows = [];
          }

          return rows.map((row, rIdx) => (

            <tr key={`${i}-${rIdx}`}>

              {/* REF DOC */}
              <td>
                {item.payment_type === 'cash_payment'
                  ? `CP/${item.inv_no}/${item.branchName || ''}`
                  : `CR/${item.inv_no}/${item.branchName || ''}`}
              </td>
              <td>
                {new Date(item.payment_date).toLocaleDateString()}
              </td>
              <td>{item.cheque_no || '-'}</td>
              <td>
                {typeof row.account === 'object'
                  ? row.account.label
                  : '-'}
              </td>
              <td>
                {item.payment_type === 'cash_receipt'
                  ? row.amount
                  : ''}
              </td>

           
              <td>
                {item.payment_type === 'bank_payment'
                  ? row.amount
                  : ''}
              </td>

            </tr>
          ));

        })}

      </React.Fragment>
    ))
  ) : (
    <tr>
      <td colSpan="6">No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}          


              {noteType?.value === 'cash_flow_sts' && (

   <>
           <div className="mb-2">
        <select
    className="form-select w-auto"
    value={typeFilter}
    onChange={(e) => setTypeFilter(e.target.value)}
  >
    {typeOptions.map((type, idx) => (
      <option key={idx} value={type}>
        {type === 'all'
          ? 'All'
          : type.replace('_', ' ')}
      </option>
    ))}
  </select>
    </div>


    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>DOC No</th>
                    <th>Date</th>
                    <th>Main Account </th>
                    <th>Amount</th>
                  
                   <th>Cr</th>
                       <th>Dr</th>
                      <th>Sub Account </th>
                        <th>Account Type </th>    
                    
                  </tr>
                </thead>
    <tbody>
{Array.isArray(fetchData) && fetchData.length > 0 ? (
  fetchData
    .filter(item => {
      if (typeFilter === 'all') return true;
       return normalize(item.account_type) === normalize(typeFilter);
    })
    .map((item, idx) => {

      let rows = [];

      try {
        rows = JSON.parse(JSON.parse(item.tableRow || "[]"));
        if (!Array.isArray(rows)) rows = [];
      } catch {
        rows = [];
      }

      return rows.map((row, rIdx) => (
        <tr key={`${idx}-${rIdx}`}>

          {/* DOC NO */}
          <td>
            {`${item.payment_type === 'bank_payment'
              ? 'BP'
              : item.payment_type === 'cash_payment'
                ? 'CP'
                : item.payment_type === 'bank_receipt'
                  ? 'BR'
                  : item.payment_type === 'cash_receipt'
                    ? 'CR'
                    : 'NA'
            }/${item.inv_no || '-'}/${item.branchName || '-'}`}
          </td>

          {/* DATE */}
          <td>
            {new Date(item.payment_date).toLocaleDateString()}
          </td>

          {/* MAIN ACCOUNT */}
          <td>{item.main_account || '-'}</td>

          {/* AMOUNT */}
          <td>{item.amount || 0}</td>

          {/* CREDIT */}
          <td>
            {item.payment_type === 'cash_receipt' ||
             item.payment_type === 'bank_receipt'
              ? item.amount
              : ''}
          </td>

          {/* DEBIT */}
          <td>
            {item.payment_type === 'cash_payment' ||
             item.payment_type === 'bank_payment'
              ? item.amount
              : ''}
          </td>

          {/* SUB ACCOUNT */}
          <td>
            {typeof row.account === 'object'
              ? row.account.label
              : '-'}
          </td>

          {/* ACCOUNT TYPE */}
          <td>{item.account_type || '-'}</td>

        </tr>
      ));

    })
) : (
  <tr>
    <td colSpan="8">No data found</td>
  </tr>
)}
</tbody>
              </table>
   </>

              
            )} 


              {noteType?.value === 'bill_wise_pay' && (
   <>
    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>DOC No</th>
                    <th>Date</th>
                    <th>Main Account </th>
                    <th>Amount</th>
                     
                      <th>Sub Account/Party Name </th>
                        <th>Sub Account Ref Doc </th>
                         <th>Total Amount </th>
                        <th>Allocated Amount  </th>    
                    
                  </tr>
                </thead>
<tbody>
{Array.isArray(fetchData) && fetchData.length > 0 ? (
  fetchData.map((item, idx) => {

    let rows = [];

    try {
      rows = JSON.parse(JSON.parse(item.tableRow || "[]"));
      if (!Array.isArray(rows)) rows = [];
    } catch {
      rows = [];
    }

    return rows.map((row, rIdx) => {

      const allocations = row.allocation || [];

      return allocations.map((alloc, aIdx) => (
        <tr key={`${idx}-${rIdx}-${aIdx}`}>

          {/* DOC NO */}
          <td>
            {item.payment_type === 'bank_payment'
              ? `BP/${item.inv_no}/${item.branchName}`
              : item.payment_type === 'cash_payment'
                ? `CP/${item.inv_no}${item.branchName}`
                : item.payment_type === 'bank_receipt'
                  ? `BR/${item.inv_no}${item.branchName}`
                  : `CR/${item.inv_no}${item.branchName}`}
          </td>

          {/* DATE */}
          <td>
            {new Date(item.payment_date).toLocaleDateString()}
          </td>

          {/* MAIN ACCOUNT */}
          <td>{item.main_account}</td>

          {/* AMOUNT */}
          <td>{row.amount}</td>

          {/* SUB ACCOUNT / PARTY NAME */}
          <td>{alloc.party || '-'}</td>

          {/* REF DOC */}
          <td>{alloc.ref_doc || '-'}</td>

          {/* TOTAL AMOUNT */}
          <td>{row.amount}</td>

          {/* ALLOCATED AMOUNT */}
          <td>{alloc.allocated_amount || 0}</td>

        </tr>
      ));

    });

  })
) : (
  <tr>
    <td colSpan="8">No data found</td>
  </tr>
)}
</tbody>
              </table>
   </>

              
            )} 

   {noteType?.value === 'bill_wise_receive' && (
   <>
    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>DOC No</th>
                    <th>Date</th>
                    <th>Main Account </th>
                    <th>Amount</th>
                     
                      <th>Sub Account/Party Name </th>
                        <th>Sub Account Ref Doc </th>
                         <th>Total Amount </th>
                        <th>Allocated Amount  </th>    
                    
                  </tr>
                </thead>
<tbody>
{Array.isArray(fetchData) && fetchData.length > 0 ? (
  fetchData.map((item, idx) => {

    let rows = [];

    try {
      rows = JSON.parse(JSON.parse(item.tableRow || "[]"));
      if (!Array.isArray(rows)) rows = [];
    } catch {
      rows = [];
    }

    return rows.map((row, rIdx) => {

      const allocations = row.allocation || [];

      return allocations.map((alloc, aIdx) => (
        <tr key={`${idx}-${rIdx}-${aIdx}`}>

          {/* DOC NO */}
          <td>
            {item.payment_type === 'bank_payment'
              ? `BP/${item.inv_no}/${item.branchName}`
              : item.payment_type === 'cash_payment'
                ? `CP/${item.inv_no}${item.branchName}`
                : item.payment_type === 'bank_receipt'
                  ? `BR/${item.inv_no}${item.branchName}`
                  : `CR/${item.inv_no}${item.branchName}`}
          </td>

          {/* DATE */}
          <td>
            {new Date(item.payment_date).toLocaleDateString()}
          </td>

          {/* MAIN ACCOUNT */}
          <td>{item.main_account}</td>

          {/* AMOUNT */}
          <td>{row.amount}</td>

          {/* SUB ACCOUNT / PARTY NAME */}
          <td>{alloc.party || '-'}</td>

          {/* REF DOC */}
          <td>{alloc.ref_doc || '-'}</td>

          {/* TOTAL AMOUNT */}
          <td>{row.amount}</td>

          {/* ALLOCATED AMOUNT */}
          <td>{alloc.allocated_amount || 0}</td>

        </tr>
      ));

    });

  })
) : (
  <tr>
    <td colSpan="8">No data found</td>
  </tr>
)}
</tbody>
              </table>
   </>

              
            )} 


            {noteType?.value === 'account_document' && (
  <>
    <table className='table table-bordered table-striped table-hover text-center align-middle'>
      <thead className='table-info'>
        <tr>
          <th>DOC No</th>
          <th>Date</th>
          <th>Name</th>
          <th>Account Code</th>
          <th>Account Type</th>
          <th>Document Type</th>
        </tr>
      </thead>

      <tbody>
        {fetchData?.map((item, index) => {

          // Document Prefix Logic
          let prefix = '';

          if (item.source_table === 'purchase') {

            if (item.type_acc === 'Inquiry') {
              prefix = 'PE';
            } else if (item.type_acc === 'Order') {
              prefix = 'PO';
            }else if (item.type_acc === 'Quotation') {
              prefix = 'PQ';
            }else if (item.type_acc === 'Return') {
              prefix = 'PR';
            }
            
            else {
              prefix = 'PU';
            }

          } else if (item.source_table === 'sales') {

            if (item.type_acc === 'sale_quotation') {
              prefix = 'SQ';
            } else if (item.type_acc === 'performa_invoice') {
              prefix = 'PI';
            }else if (item.type_acc === 'sale_invoice') {
              prefix = 'SI';
            }  else if (item.type_acc === 'sale_return') {
              prefix = 'SR';
            } 
            
            else {
              prefix = 'DC';
            }

          } else if (item.source_table === 'repair_item') {

            if (item.type_acc === 'repair_invoice') {
              prefix = 'RI';
            } else {
              prefix = 'R';
            }

          } else if (item.source_table === 'complaints') {

            prefix = 'CMP';

          } else if (item.source_table === 'pms_schedule') {

            prefix = 'PMS';
          }

        
      let docNumber = '';

if (item.source_table === 'pms_schedule') {

 
  docNumber = item.inv_no || '-';

} else {

  // All other documents
  docNumber = item.inv_no
    ? `${prefix}/${item.inv_no}/${item.branchId || item.branchName}`
    : `${prefix}/${item.id}/${item.branchId || item.branchName}`;
}

          return (
            <tr key={index}>

              <td>{docNumber}</td>

              <td>
                {item.payment_date
                  ? new Date(item.payment_date).toLocaleDateString('en-GB')
                  : '-'}
              </td>

              <td>{item.party_name || '-'}</td>

              <td>{item.account_code || '-'}</td>

              <td>{item.type_account || '-'}</td>

              <td style={{ textTransform: 'capitalize' }}>
                {item.source_table?.replace('_', ' ')}
              </td>

            </tr>
          );
        })}
      </tbody>
    </table>
  </>
)}


{noteType?.value === 'account_master' && (() => {

  // Get unique account types for dropdown
  const accountTypes = [...new Set(
    fetchData?.map(item => item.type_acc).filter(Boolean)
  )];

  // Filter data based on dropdown selection
  const filteredData = selectedType === 'all'
    ? fetchData
    : fetchData?.filter(item => item.type_acc === selectedType);

  // Group filtered data
  const groupedData = filteredData?.reduce((acc, item) => {

    const key = item.type_acc || 'Others';

    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(item);

    return acc;

  }, {});

  return (
    <>

      {/* Dropdown Filter */}
      <div className="mb-3 w-25">

        <label className='form-label fw-bold'>
          Filter By Account Type
        </label>

        <select
          className='form-select'
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
        >

          <option value="all">All</option>

          {accountTypes.map((type, index) => (
            <option key={index} value={type}>
              {type}
            </option>
          ))}

        </select>
      </div>

      <table className='table table-bordered table-striped table-hover align-middle'>

        <thead className='table-info text-center'>
          <tr>
            <th width="20%">Account Type</th>
            <th width="20%">Account Code</th>
            <th>Account Name</th>
          </tr>
        </thead>

        <tbody>

          {Object.entries(groupedData || {}).map(([groupName, accounts], groupIndex) => (
            <React.Fragment key={groupIndex}>

              {/* Group Header */}
              <tr className='table-secondary'>
                <td colSpan={3} className='fw-bold text-start'>
                  {groupName} ({accounts.length})
                </td>
              </tr>

              {/* Accounts */}
              {accounts.map((item, index) => (
                <tr key={index} className='text-center'>

                  <td>-</td>

                  <td>{item.code || '-'}</td>

                  <td className='text-start'>
                    {item.holder_name || '-'}
                  </td>

                </tr>
              ))}

            </React.Fragment>
          ))}

        </tbody>

      </table>

    </>
  );
})()}



{noteType?.value === 'outstand_bill' && (
  <>
    <table className='table table-bordered table-striped table-hover text-center align-middle'>
      <thead className='table-info'>
        <tr>
          <th>DOC No</th>
          <th>Date</th>
          <th>Party Name</th>
          <th>Bill Amount</th>
          <th>Received Amount</th>
          <th>Balanced Amount</th>
        </tr>
      </thead>

      <tbody>
        {fetchData?.map((item, index) => {

          const billAmount = parseFloat(item.grand_total || 0);
          const receivedAmount = parseFloat(item.received_amount || 0);
          const balancedAmount = billAmount - receivedAmount;

          return (
            <tr key={index}>

              <td>
                {item.source_table === 'sales'
                  ? `SI/${item.inv_no || item.id}/${item.branchId || item.branchName}`
                  : item.source_table === 'purchase'
                  ? `PU/${item.inv_no || item.id}/${item.branchId || item.branchName}`
                  : item.source_table === 'repair_item'
                  ? `RI/${item.inv_no || item.id}/${item.branchId || item.branchName}`
                  : item.source_table === 'amc_detail'
                  ? `AMC/${item.ref_doc || item.id}/${item.branchId || item.branchName}`
                  : `CMP/${item.id}/${item.branchId || item.branchName}`}
              </td>

              <td>
                {item.payment_date
                  ? new Date(item.payment_date).toLocaleDateString('en-GB')
                  : '-'}
              </td>

              <td>{item.party_name || '-'}</td>

              <td>{billAmount.toFixed(2)}</td>

              <td>{receivedAmount.toFixed(2)}</td>

              <td style={{ color: balancedAmount > 0 ? 'red' : 'green', fontWeight: 'bold' }}>
                {balancedAmount.toFixed(2)}
              </td>

            </tr>
          );
        })}
      </tbody>
    </table>
  </>
)}

{noteType?.value === 'unallocated_voucher' && (
  <>
    <table className='table table-bordered table-striped table-hover text-center align-middle'>
      <thead className='table-info'>
        <tr>
          <th>DOC No</th>
          <th>Date</th>
          <th>Party Name</th>
          <th>Bill Amount</th>
          <th>Allocated Amount</th>
          <th>Doc Type</th>
        </tr>
      </thead>

      <tbody>
      {fetchData?.map((item, index) => {

  const allocation = item?.parsedRows?.[0]?.allocation?.[0];

  // ✅ ONLY ADDED FILTER (DO NOT CHANGE ANYTHING ELSE)
  if (!allocation || allocation.length === 0) return null;

  const allocatedAmount = parseFloat(allocation?.allocated_amount || 0);
  const balanceAmount = parseFloat(allocation?.balance_amount || 0);

  // TOTAL BILL (correct logic)
  const billAmount = allocatedAmount + balanceAmount;

  // SHOW ONLY UNALLOCATED / PARTIALLY ALLOCATED
  const showRow =
    !allocation ||
    balanceAmount > 0;

  if (!showRow) return null;

  const partyName =
    item?.parsedRows?.[0]?.account?.label ||
    item?.account_holder_name ||
    allocation?.party ||
    '-';

  let docType = '';

  if (item.payment_type === 'bank_payment') {
    docType = 'Bank Payment';
  } else if (item.payment_type === 'bank_receipt') {
    docType = 'Bank Receipt';
  } else if (item.payment_type === 'cash_payment') {
    docType = 'Cash Payment';
  } else if (item.payment_type === 'cash_receipt') {
    docType = 'Cash Received';
  }

  let docNo = '';

  if (item.payment_type === 'bank_payment') {
    docNo = `BP/${item.inv_no || item.id}/${item.branchName || '-'}`;
  } else if (item.payment_type === 'bank_receipt') {
    docNo = `BR/${item.inv_no || item.id}/${item.branchName || '-'}`;
  } else if (item.payment_type === 'cash_payment') {
    docNo = `CP/${item.inv_no || item.id}/${item.branchName || '-'}`;
  } else if (item.payment_type === 'cash_receipt') {
    docNo = `CR/${item.inv_no || item.id}/${item.branchName || '-'}`;
  } else {
    docNo = item.inv_no || item.id;
  }

  return (
    <tr key={index}>

      <td>{docNo}</td>

      <td>
        {item.payment_date
          ? new Date(item.payment_date).toLocaleDateString('en-GB')
          : '-'}
      </td>

      <td>{partyName}</td>

      <td>{billAmount}</td>

      <td>{allocatedAmount}</td>

      <td>{docType}</td>

    </tr>
  );
})}
      </tbody>
    </table>
  </>
)}



{noteType?.value === 'general_ledger' && (() => {

  return (
    <>
      <table className='table table-bordered table-striped table-hover align-middle'>

        <thead className='table-info text-center'>
          <tr>
            <th>Doc No</th>
            <th>Date</th>
            <th>Account Type</th>
          
            {/* <th>Sub Account</th>
            <th>Doc Type</th> */}
            <th>Debit</th>
            <th>Credit</th>
             <th>Opening Balance</th>
              <th>Closing Balance</th>
          </tr>
        </thead>
<tbody>

  {Object.entries(groupedData || {}).map(([mainGroup, subGroups]) => (

    <React.Fragment key={mainGroup}>

      {/* MAIN GROUP */}
      <tr className="table-primary">
        <td colSpan={8} className="fw-bold text-start">
          {mainGroup}
        </td>
      </tr>

      {Object.entries(subGroups).map(([subGroup, transactions]) => (

        <React.Fragment key={subGroup}>

          {/* SUB GROUP */}
          <tr className="table-secondary">
            <td colSpan={8} className="fw-bold ps-4 text-start">
              {subGroup}
            </td>
          </tr>

          {(() => {

            // OPENING BALANCE
            let runningBalance = parseFloat(
              transactions[0]?.opening_balance || 0
            );

            return (
              <>

                {/* OPENING BALANCE ROW */}
                <tr className="table-warning text-center">

                  <td colSpan={6} className="fw-bold text-end">
                    Opening Balance
                  </td>

                  <td colSpan={2} className="fw-bold">

                    {Math.abs(runningBalance).toFixed(2)}

                    {' '}

                    {runningBalance >= 0 ? 'Dr' : 'Cr'}

                  </td>

                </tr>

                {/* TRANSACTIONS */}
                {transactions.map((item, index) => {

                  let prefix = '';

                  // SALES
                  if (item.source_table === 'sales') {

                    if (item.type_acc === 'sale_invoice') {
                      prefix = 'SI';
                    }
                    else if (item.type_acc === 'sale_return') {
                      prefix = 'SR';
                    }
                    else {
                      prefix = 'SA';
                    }

                  }

                  // PURCHASE
                  else if (item.source_table === 'purchase') {

                    prefix = 'PU';

                  }

                  // REPAIR
                  else if (item.source_table === 'repair_item') {

                    prefix = 'RI';

                  }

                  // AMC
                  else if (item.source_table === 'amc_detail') {

                    prefix = 'AMC';

                  }

                  // PAYMENT
                  else if (item.source_table === 'payment_detail') {

                    if (item.type_acc === 'bank_payment') {
                      prefix = 'BP';
                    }
                    else if (item.type_acc === 'bank_receipt') {
                      prefix = 'BR';
                    }
                    else if (item.type_acc === 'cash_payment') {
                      prefix = 'CP';
                    }
                    else if (item.type_acc === 'cash_receipt') {
                      prefix = 'CR';
                    }

                  }

                  // DOC NO
                  const docNo =
                    `${prefix}/${item.inv_no || item.id}/${item.branchId || '-'}`;

                  // AMOUNT
                  // const amount = parseFloat(
                  //   item.grand_total ||
                  //   item.received_amount ||
                  //   item.amount ||
                  //   0
                  // );

             const amount = parseFloat(
  item.parsedRows?.[0]?.amount ||
  item.received_amount ||
  item.amount ||
  item.grand_total ||
  0
);

                  let drAmount = '';
                  let crAmount = '';

                  const type = (item.type_acc || '').toLowerCase();

                  // CREDIT ENTRY
                  if (
                    type === 'sale_invoice' ||
                    type === 'bank_receipt' ||
                    type === 'cash_receipt'
                  ) {

                    crAmount = amount.toFixed(2);

                    runningBalance -= amount;

                  }

                  // DEBIT ENTRY
                  else {

                    drAmount = amount.toFixed(2);

                    runningBalance += amount;

                  }

                  // DOC TYPE
                  let docType = '';

                  if (item.source_table === 'sales') {
                    docType = 'Sales';
                  }
                  else if (item.source_table === 'purchase') {
                    docType = 'Purchase';
                  }
                  else if (item.source_table === 'repair_item') {
                    docType = 'Repair';
                  }
                  else if (item.source_table === 'amc_detail') {
                    docType = 'AMC';
                  }
                  else if (item.source_table === 'payment_detail') {

                    if (type === 'bank_payment') {
                      docType = 'Bank Payment';
                    }
                    else if (type === 'bank_receipt') {
                      docType = 'Bank Receipt';
                    }
                    else if (type === 'cash_payment') {
                      docType = 'Cash Payment';
                    }
                    else if (type === 'cash_receipt') {
                      docType = 'Cash Receipt';
                    }
                    else {
                      docType = 'Payment';
                    }

                  }
                  else {
                    docType = item.source_table;
                  }

                  return (

                    <tr key={index} className='text-center'>

                      {/* DOC NO */}
                      <td>{docNo}</td>

                      {/* DATE */}
                      <td>
                        {item.payment_date
                          ? new Date(item.payment_date)
                            .toLocaleDateString('en-GB')
                          : '-'}
                      </td>

               
                       {/* <td>
                        {item.master_type_account || '-'}
                      </td> */}

                  
                      {/* <td className="text-start">
                        {subGroup}
                      </td>  */}

                      {/* DOC TYPE */}
                      <td>
                        {docType}
                      </td>

                      {/* DR */}
                      <td>
                        {drAmount || '-'}
                      </td>

                      {/* CR */}
                      <td>
                        {crAmount || '-'}
                      </td>

                      {/* RUNNING BALANCE */}
                      <td>

                        {Math.abs(runningBalance).toFixed(2)}

                        {' '}

                        {runningBalance >= 0 ? 'Dr' : 'Cr'}

                      </td>

                    </tr>

                  );

                })}

                {/* CLOSING BALANCE */}
                <tr className="table-success text-center">

                  <td colSpan={6} className="fw-bold text-end">
                    Closing Balance
                  </td>

                  <td colSpan={2} className="fw-bold">

                    {Math.abs(runningBalance).toFixed(2)}

                    {' '}

                    {runningBalance >= 0 ? 'Dr' : 'Cr'}

                  </td>

                </tr>

              </>
            );

          })()}

        </React.Fragment>

      ))}

    </React.Fragment>

  ))}

</tbody>

      </table>

    </>
  );
})()}



{noteType?.value === 'ledger_job_wise' && (() => {

  return (
    <>
      <table className='table table-bordered table-striped table-hover align-middle'>

        <thead className='table-info text-center'>
          <tr>
            <th>Doc No</th>
            <th>Date</th>
       
            <th>Party</th>
            <th>Doc Type</th>
            <th>Dr</th>
            <th>Cr</th>
          </tr>
        </thead>

        <tbody>

          {fetchData?.map((item, index) => {

            const accountName =
              item?.party_name ||
              item?.account_code ||
              '-';

            let prefix = '';

            // SALES
            if (item.source_table === 'sales') {

              if (item.type_acc === 'sale_invoice') {
                prefix = 'SI';
              } else if (item.type_acc === 'sale_quotation') {
                prefix = 'SQ';
              } else if (item.type_acc === 'sale_return') {
                prefix = 'SR';
              } else {
                prefix = 'SA';
              }

            }

            // PURCHASE
            else if (item.source_table === 'purchase') {

              if (item.type_acc === 'Purchase') {
                prefix = 'PU';
              } else {
                prefix = 'PR';
              }

            }

            // REPAIR
            else if (item.source_table === 'repair_item') {

              prefix = 'RI';

            }

            // AMC
            else if (item.source_table === 'amc_detail') {

              prefix = 'AMC';

            }

            // PAYMENT
            else if (item.source_table === 'payment_detail') {

              if (item.type_acc === 'bank_payment') {
                prefix = 'BP';
              }
              else if (item.type_acc === 'bank_receipt') {
                prefix = 'BR';
              }
              else if (item.type_acc === 'cash_payment') {
                prefix = 'CP';
              }
              else if (item.type_acc === 'cash_receipt') {
                prefix = 'CR';
              }

            }

            // DOC NO
            const docNo =
              `${prefix}/${item.inv_no || item.id}/${item.branchId || '-'}`;

            // AMOUNT
            const amount = parseFloat(
              item.grand_total ||
              item.received_amount ||
              item.amount ||
              0
            );

            let drAmount = '';
            let crAmount = '';

            const type = (item.type_acc || '').toLowerCase();

            // CREDIT
            if (
              type === 'sale_invoice' ||
              type === 'bank_receipt' ||
              type === 'cash_receipt'
            ) {

              crAmount = amount.toFixed(2);

            }

            // DEBIT
            else if (
              type === 'purchase' ||
              type === 'repair_item' ||
              type === 'amc' ||
              type === 'bank_payment' ||
              type === 'cash_payment'
            ) {

              drAmount = amount.toFixed(2);

            }

            // DOC TYPE DISPLAY
            let docType = '';

            if (item.source_table === 'sales') {
              docType = 'Sales';
            }
            else if (item.source_table === 'purchase') {
              docType = 'Purchase';
            }
            else if (item.source_table === 'repair_item') {
              docType = 'Repair';
            }
            else if (item.source_table === 'amc_detail') {
              docType = 'AMC';
            }
            else if (item.source_table === 'payment_detail') {

              if (type === 'bank_payment') {
                docType = 'Bank Payment';
              }
              else if (type === 'bank_receipt') {
                docType = 'Bank Receipt';
              }
              else if (type === 'cash_payment') {
                docType = 'Cash Payment';
              }
              else if (type === 'cash_receipt') {
                docType = 'Cash Receipt';
              }
              else {
                docType = 'Payment';
              }

            }
            else {
              docType = item.source_table;
            }

            return (
              <tr key={index} className='text-center'>

                <td>{docNo}</td>

                <td>
                  {item.payment_date
                    ? new Date(item.payment_date).toLocaleDateString('en-GB')
                    : '-'}
                </td>


                <td className='text-start'>
                  {accountName}
                </td>

                <td>
                  {docType}
                </td>

                <td>{drAmount || '-'}</td>

                <td>{crAmount || '-'}</td>

              </tr>
            );

          })}

        </tbody>

      </table>

    </>
  );
})()}


{noteType?.value === 'trail_balance' && (() => {

  let grandTotalDr = 0;
  let grandTotalCr = 0;

  return (
    <>

    <div className="mb-3">

  <select
    className="form-select w-25"
    value={selectedGroup}
    onChange={(e) => setSelectedGroup(e.target.value)}
  >

    <option value="ALL">All Groups</option>

    {Object.keys(trialBalanceGroupedData || {}).map(group => (
      <option key={group} value={group}>
        {group}
      </option>
    ))}

  </select>

</div>


      <table className='table table-bordered table-striped table-hover align-middle'>

        <thead className='table-info text-center'>
          <tr>
            <th>Account Name</th>
            <th>Debit</th>
            <th>Credit</th>
          </tr>
        </thead>

        <tbody>

          {Object.entries(trialBalanceGroupedData || {}).filter(([groupHead]) =>
    selectedGroup === 'ALL' || groupHead === selectedGroup
  ).map(([groupHead, accounts]) => (

            <React.Fragment key={groupHead}>

              {/* MASTER GROUP */}
              <tr className="table-primary">
                <td colSpan={3} className="fw-bold text-start">
                  {groupHead}
                </td>
              </tr>

              {Object.entries(accounts).map(([accountName, items]) => {

                let totalDr = 0;
                let totalCr = 0;

                items.forEach(item => {

                  const amount = parseFloat(
                    item.parsedRows?.[0]?.amount ||
                    item.amount ||
                    0
                  );

                  const type = (item.payment_type || item.type_acc || '').toLowerCase();

                  // CREDIT
                  if (
                    type === 'bank_receipt' ||
                    type === 'cash_receipt' ||
                    type === 'sale_invoice'
                  ) {
                    totalCr += amount;
                  }

                  // DEBIT
                  else {
                    totalDr += amount;
                  }

                });

                // GRAND TOTALS
                grandTotalDr += totalDr;
                grandTotalCr += totalCr;

                return (
                  <tr key={accountName} className="text-center">

                    {/* ACCOUNT NAME */}
                    <td className="text-start ps-4">
                      {accountName}
                    </td>

                    {/* DEBIT */}
                    <td>
                      {totalDr.toFixed(2)}
                    </td>

                    {/* CREDIT */}
                    <td>
                      {totalCr.toFixed(2)}
                    </td>

                  </tr>
                );

              })}

            </React.Fragment>

          ))}

          {/* GRAND TOTAL ROW */}
          <tr className="table-success fw-bold text-center">

            <td className="text-end">
              TOTAL
            </td>

            <td>
              {grandTotalDr.toFixed(2)}
            </td>

            <td>
              {grandTotalCr.toFixed(2)}
            </td>

          </tr>

          {/* DIFFERENCE ROW */}
          <tr className="table-warning fw-bold text-center">

            <td className="text-end">
              DIFFERENCE
            </td>

            <td colSpan={2}>

              {Math.abs(grandTotalDr - grandTotalCr).toFixed(2)}

              {' '}

              {grandTotalDr > grandTotalCr ? 'Dr' : 'Cr'}

            </td>

          </tr>

        </tbody>

      </table>
    </>
  );

})()}


{noteType?.value === 'trail_balance_detail' && (() => {

  let grandTotalDr = 0;
  let grandTotalCr = 0;

  return (
    <>
      {/* FILTER */}
      <div className="mb-3">
        <select
          className="form-select w-25"
          value={selectedGroup}
          onChange={(e) => setSelectedGroup(e.target.value)}
        >
          <option value="ALL">All Groups</option>

          {Object.keys(trialBalanceGroupedData || {}).map(group => (
            <option key={group} value={group}>
              {group}
            </option>
          ))}
        </select>
      </div>

      <table className='table table-bordered table-striped table-hover align-middle'>

        <thead className='table-info text-center'>
          <tr>
            <th>Account Name</th>
            <th>Opening</th>
            <th>Debit</th>
            <th>Credit</th>
            <th>Balance</th>
          </tr>
        </thead>

     <tbody>

  {computedData
    .filter(g => selectedGroup === 'ALL' || g.groupHead === selectedGroup)
    .map(group => (

      <React.Fragment key={group.groupHead}>

        {/* GROUP HEADER */}
        <tr className="table-primary">
          <td colSpan={5} className="fw-bold text-start">
            {group.groupHead}
          </td>
        </tr>

        {/* ACCOUNTS */}
        {group.accounts.map(acc => (
          <tr key={acc.accountName} className="text-center">

            <td className="text-start ps-4">
              {acc.accountName}
            </td>

            <td>{acc.openingBalance.toFixed(2)}</td>
            <td>{acc.totalDr.toFixed(2)}</td>
            <td>{acc.totalCr.toFixed(2)}</td>
            <td className="fw-bold">
              {acc.runningBalance.toFixed(2)}
            </td>

          </tr>
        ))}

        {/* GROUP TOTAL */}
        <tr className="table-warning fw-bold text-center">
          <td className="text-end">Group Total</td>
          <td>-</td>
          <td>{group.groupDr.toFixed(2)}</td>
          <td>{group.groupCr.toFixed(2)}</td>
          <td>{(group.groupDr - group.groupCr).toFixed(2)}</td>
        </tr>

      </React.Fragment>
    ))}

</tbody>

      </table>
    </>
  );

})()}

{noteType?.value === 'profit_and_loss' && (() => {

  let totalExpense = 0;
  let totalIncome = 0;

  return (
    <>
      <table className='table table-bordered table-striped table-hover align-middle'>

        <thead className='table-info text-center'>
          <tr>
            <th>Account Name</th>
            <th>Debit (Expense)</th>
            <th>Credit (Income)</th>
          </tr>
        </thead>

        <tbody>

          {Object.entries(plGrouped || {}).map(([accountName, data]) => {

            totalExpense += data.dr;
            totalIncome += data.cr;

            return (
              <tr key={accountName} className="text-center">

                <td className="text-start ps-4">
                  {accountName}
                </td>

                <td>
                  {data.dr.toFixed(2)}
                </td>

                <td>
                  {data.cr.toFixed(2)}
                </td>

              </tr>
            );

          })}

          {/* TOTAL EXPENSE */}
          <tr className="table-danger fw-bold text-center">
            <td className="text-end">TOTAL EXPENSE</td>
            <td>{totalExpense.toFixed(2)}</td>
            <td>-</td>
          </tr>

          {/* TOTAL INCOME */}
          <tr className="table-success fw-bold text-center">
            <td className="text-end">TOTAL INCOME</td>
            <td>-</td>
            <td>{totalIncome.toFixed(2)}</td>
          </tr>

          {/* PROFIT / LOSS */}
          <tr className="table-warning fw-bold text-center">

            <td className="text-end">NET PROFIT / LOSS</td>

            <td colSpan={2}>

              {totalIncome - totalExpense > 0 ? (
                <>
                  Profit: {(totalIncome - totalExpense).toFixed(2)}
                </>
              ) : (
                <>
                  Loss: {(totalExpense - totalIncome).toFixed(2)}
                </>
              )}

            </td>

          </tr>

        </tbody>

      </table>
    </>
  );

})()}



{noteType?.value === 'stock_statement' && (() => {

 
  const stockData = fetchData || [];


  let totalOpeningQty = 0;
  let totalOpeningValue = 0;

  let totalPurchaseQty = 0;
  let totalPurchaseValue = 0;

  let totalSalesQty = 0;
  let totalSalesValue = 0;

  let totalClosingQty = 0;
  let totalClosingValue = 0;

  return (
    <>

      <table className='table table-bordered table-striped table-hover align-middle'>


        <thead className='table-info text-center'>

          <tr>

            <th>Item</th>

            <th>Op Qty</th>
            <th>Op Value</th>

            <th>Purchase Qty</th>
            <th>Purchase Value</th>

            <th>Sale Qty</th>
            <th>Sale Value</th>

            <th>Bal Qty</th>
            <th>Balance Value</th>

            <th>Last Purchase Qty</th>
            <th>Last Purchase Value</th>

            <th>Last Sale Qty</th>
            <th>Last Sale Value</th>

            <th>Last Sale Date</th>

            <th>UOM</th>

          </tr>

        </thead>


        <tbody>

          {stockData.map((item, index) => {

      
            totalOpeningQty += Number(item.opening_qty || 0);
            totalOpeningValue += Number(item.opening_value || 0);

            totalPurchaseQty += Number(item.purchase_qty || 0);
            totalPurchaseValue += Number(item.purchase_value || 0);

            totalSalesQty += Number(item.sales_qty || 0);
            totalSalesValue += Number(item.sales_value || 0);

            totalClosingQty += Number(item.closing_qty || 0);
            totalClosingValue += Number(item.closing_value || 0);

            return (

              <tr key={index} className='text-center'>

                {/* ITEM */}
                <td className='text-start fw-bold'>
                  {item.name}
                </td>

                {/* OPENING */}
                <td>
                  {Number(item.opening_qty || 0).toFixed(2)}
                </td>

                <td>
                  {Number(item.opening_value || 0).toFixed(2)}
                </td>

                {/* PURCHASE */}
                <td>
                  {Number(item.purchase_qty || 0).toFixed(2)}
                </td>

                <td>
                  {Number(item.purchase_value || 0).toFixed(2)}
                </td>

                {/* SALES */}
                <td>
                  {Number(item.sales_qty || 0).toFixed(2)}
                </td>

                <td>
                  {Number(item.sales_value || 0).toFixed(2)}
                </td>

                {/* CLOSING */}
                <td className='fw-bold text-success'>
                  {Number(item.closing_qty || 0).toFixed(2)}
                </td>

                <td className='fw-bold text-success'>
                  {Number(item.closing_value || 0).toFixed(2)}
                </td>

                {/* LAST PURCHASE */}
                <td>
                  {Number(item.last_purchase_qty || 0).toFixed(2)}
                </td>

                <td>
                  {Number(item.last_purchase_value || 0).toFixed(2)}
                </td>

                {/* LAST SALE */}
                <td>
                  {Number(item.last_sale_qty || 0).toFixed(2)}
                </td>

                <td>
                  {Number(item.last_sale_value || 0).toFixed(2)}
                </td>

                {/* LAST SALE DATE */}
                <td>
                  {item.last_sale_date || '-'}
                </td>

                {/* UOM */}
                <td>
                  {item.uom || '-'}
                </td>

              </tr>

            );

          })}


          {/* <tr className='table-success fw-bold text-center'>

            <td>Total</td>

            <td>
              {totalOpeningQty.toFixed(2)}
            </td>

            <td>
              {totalOpeningValue.toFixed(2)}
            </td>

            <td>
              {totalPurchaseQty.toFixed(2)}
            </td>

            <td>
              {totalPurchaseValue.toFixed(2)}
            </td>

            <td>
              {totalSalesQty.toFixed(2)}
            </td>

            <td>
              {totalSalesValue.toFixed(2)}
            </td>

            <td>
              {totalClosingQty.toFixed(2)}
            </td>

            <td>
              {totalClosingValue.toFixed(2)}
            </td>

            <td colSpan={5}>-</td>

          </tr> */}

        </tbody>

      </table>

    </>
  );

})()}




{noteType?.value === 'balance_sheet' && (
  <>
    <table className='table table-bordered table-striped table-hover text-center align-middle'>

      <thead className='table-info'>
        <tr>
          <th>Account Holder Name</th>
          <th>Amount</th>
          <th>Schedule Name</th>
          <th>Schedule Type</th>
          <th>Account Type</th>
        </tr>
      </thead>

      <tbody>

        {fetchData?.map((item, index) => (

          <tr key={index}>

   
            <td className="text-start fw-medium">
              {item.holder_name || '-'}
            </td>
        
             <td>
              {item.
total_payment_amount
 || '-'}
            </td>
   
            <td>
              {item.schedule_name || '-'}
            </td>

            <td className="text-uppercase">
              {item.schedule_type || '-'}
            </td>

 
            <td>
              {item.type_account || '-'}
            </td>

          </tr>

        ))}

      </tbody>

    </table>
  </>
)}


{noteType?.value === 'trading_account' && (
  <>
    {/* DROPDOWN */}
    <div className="mb-3">
      <select
        className="form-control w-25"
        value={filterType}
        onChange={(e) => setFilterType(e.target.value)}
      >
        <option value="all">All</option>
        <option value="sales">Sales</option>
        <option value="purchase">Purchase</option>
        <option value="amc">AMC</option>
        <option value="expense">Indirect Expense</option>
      </select>
    </div>

    {/* TABLE */}
    <table className="table table-bordered table-striped text-center">

      <thead className="table-info">
        <tr>
          <th>Group</th>
          <th>Total Amount</th>
        </tr>
      </thead>

      <tbody>

        {(filterType === "all" || filterType === "sales") && (
          <tr>
            <td>Sales</td>
       <td>{totals.sales}</td>
          </tr>
        )}

        {(filterType === "all" || filterType === "purchase") && (
          <tr>
            <td>Purchase</td>
       <td>{totals.purchase}</td>
          </tr>
        )}

        {(filterType === "all" || filterType === "amc") && (
          <tr>
            <td>AMC</td>
       <td>{totals.amc}</td>
          </tr>
        )}

        {(filterType === "all" || filterType === "expense") && (
          <tr>
            <td>Indirect Expense</td>
        <td>{totals.expense}</td>
          </tr>
        )}

      </tbody>
    </table>
  </>
)}
 </div>


 {showYearModal && (
  <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog">
      <div className="modal-content">

        {/* HEADER */}
        <div className="modal-header">
          <h5 className="modal-title">Account Balance Carry-forward</h5>
          <button
            className="btn-close"
            disabled={closePending}
            onClick={() => setShowYearModal(false)}
          />
        </div>

        {/* BODY */}
        <div className="modal-body">

          {yearPreviewLoading && <p role="status">Loading financial year dates...</p>}
          {yearMessage && <div className="alert alert-warning" role="alert">{yearMessage}</div>}
          {yearContext && (
            <>
              <p><b>Source FY: {yearContext.source.financial_year}</b><br />
                {yearContext.source.from_date} to {yearContext.source.to_date}</p>
              <p><b>Target FY: {yearContext.target.financial_year}</b><br />
                {yearContext.target.from_date} to {yearContext.target.to_date}
                {!yearContext.target.id && <span className="d-block text-muted small">The next financial year will be created.</span>}
              </p>
              <p>This will close account balances for {yearContext.source.financial_year} and carry the closing balances as openings into {yearContext.target.financial_year}.</p>
            </>
          )}
          {closePending && <p role="status">Closing account balances. Please wait...</p>}

          <hr />

          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="confirmCheck"
              checked={confirmProcess}
              disabled={closePending || yearPreviewLoading || !yearContext || !!yearMessage}
              onChange={(e) => setConfirmProcess(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="confirmCheck">
              I confirm to close and carry forward these account balances
            </label>
          </div>

        </div>

        {/* FOOTER */}
        <div className="modal-footer">

          <button
            className="btn btn-secondary"
            disabled={closePending}
            onClick={() => setShowYearModal(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-danger"
            disabled={!confirmProcess || closePending || yearPreviewLoading || !yearContext || !!yearMessage}
            onClick={handleFinancialYearChange}
          >
            {closePending ? 'Processing...' : 'Close Account Balances'}
          </button>

        </div>

      </div>
    </div>
  </div>
)}

           </div>
      </div>
  </>
  )
}

export default AccountReport
